// Create message for restricted products
export const createRestrictedMessage = (restrictedProductLimit: number | undefined) => {
    if (restrictedProductLimit === undefined) return
    if (restrictedProductLimit === 0) return 'This item is currently unavailable'
    if (restrictedProductLimit > 0) {
      const itemText = restrictedProductLimit > 1 ? 'items' : 'item'
      return `Only ${restrictedProductLimit} ${itemText} of this type allowed`
    }
  }